import React, { Suspense, useState } from 'react'
import { ErrorBoundary } from 'react-error-boundary'

interface DynamicSuspenseContainerProps {
  children: React.ReactNode
  fallback: React.ReactElement
  errorFallBack?: React.ReactElement
}

const DynamicSuspenseContainer: React.FC<DynamicSuspenseContainerProps> = ({
  children,
  fallback,
  errorFallBack,
}): React.ReactElement => {
  const [err, setErr] = useState('')
  const FallbackComponent = (): React.ReactElement =>
    errorFallBack ?? <p>{err}</p>

  return (
    <ErrorBoundary
      FallbackComponent={FallbackComponent}
      onError={(error): void => {
        setErr(`⚠️ ${error.message}`)
      }}
    >
      <Suspense fallback={fallback}>{children}</Suspense>
    </ErrorBoundary>
  )
}

export default DynamicSuspenseContainer
